export default __webpack_public_path__ + "static/media/ExcellentSmiley.c451ed46.svg";